import {
	type MessageWithRefreshStrategy,
	queryClient,
	SociosSocketEvent,
	type SocketsListener,
	useSocketEventListener,
	withRefreshStrategy
} from '@capsicum/common';
import { useMemo } from 'react';

export const useProductUpdateFromWS = (
	productId: string,
	updateCallback?: (data: MessageWithRefreshStrategy) => void
) => {
	const listeners = useMemo(() => {
		return new Map<SociosSocketEvent, SocketsListener>([
			[
				SociosSocketEvent.FANSHOP_PRODUCT_UPDATED,
				withRefreshStrategy({
					listener: data => {
						queryClient.invalidateQueries({
							queryKey: ['fanshopProductUpdateFromWS']
						});

						if (productId === data?.payload?.id) {
							updateCallback?.(data);
						}
					}
				})
			]
		]);
	}, [productId, updateCallback]);

	useSocketEventListener(listeners, !!productId);
};
